import { Datagrid, useFieldLabel } from "ra-friendsofbabba";
import { DateField, List as RaList, TextField } from "react-admin";

import DownloadButton from "./buttons/DownloadButton";
import Filters from "./Filters";
import React from "react";

const List = (props) => {
  const fieldLabel = useFieldLabel(props);
  return (
    <RaList
      {...props}
      filters={<Filters />}
      sort={{ field: "created", order: "DESC" }}
    >
      <Datagrid {...props}>
        <TextField source="id" label="ID" />
        <TextField source="media.file.name" label={fieldLabel("media_id")} />
        <DateField source="created" showTime />
        <DownloadButton />
      </Datagrid>
    </RaList>
  );
};

export default List;
